var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParticipantePreenchido(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.5C4.46688 3.5 5.25 2.71688 5.25 1.75C5.25 0.783125 4.46688 0 3.5 0C2.53312 0 1.75 0.783125 1.75 1.75C1.75 2.71688 2.53312 3.5 3.5 3.5ZM3.5 4.375C2.33187 4.375 0 4.96125 0 6.125V6.5625C0 6.80313 0.196875 7 0.4375 7H6.5625C6.80313 7 7 6.80313 7 6.5625V6.125C7 4.96125 4.66813 4.375 3.5 4.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantePreenchido);
export default __webpack_public_path__ + "static/media/participante_preenchido.1ca9c3c2c12f45036f6fd1b7d6e83fee.svg";
export { ForwardRef as ReactComponent };